import { endpoints } from "@/config/endpoints";
import { apiService } from "@/services/apiService";

export default {
  addAccount(code) {
    return apiService.post(endpoints.facebook.accounts, { code });
  },
  getAccounts() {
    return apiService.get(endpoints.facebook.accounts);
  },
  deleteAccount(id) {
    return apiService.delete(endpoints.facebook.deleteAccount(id));
  },
  enablePages(facebook_pages = []) {
    return apiService.post(endpoints.facebook.enablePages, {
      facebook_pages
    });
  },
  deletePage(id) {
    return apiService.delete(endpoints.facebook.deletePage(id));
  },
  getPosts(payload) {
    return apiService.post(endpoints.facebook.posts, payload);
  },
  getPages() {
    return apiService.get(endpoints.facebook.pages);
  }
};
